export const sources={webp:"__VITE_ASSET__uHWDhY1l__ 56w"};export const img={src:"__VITE_ASSET__T8vpITik__",w:56,h:56};export default{sources:sources,img:img};